if (window.location.pathname === '/policies/shipping-policy') {
  window.location.replace('/pages/delivery-terms' + window.location.search + window.location.hash);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reducedMotion.addEventListener('change', () => {
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    });

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      if (this.reducedMotion.matches) {
        this.autoplayButtonIsSetToPlay = false;
        this.togglePlayButtonState(true);
        this.pause();
      } else {
        this.autoplayButtonIsSetToPlay = true;
        this.startInitialAutoPlay();
      }
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.startInitialAutoPlay();
    }
  }

  startInitialAutoPlay() {
    // On mobile, let the first hero remain the LCP candidate during the
    // critical loading window. Later carousel images can otherwise replace
    // it and push LCP out by multiple rotation intervals. Announcement bars
    // and desktop slideshows retain their original timing.
    if (!this.announcementBarSlider && window.matchMedia('(max-width: 749px)').matches) {
      clearTimeout(this.initialAutoplayTimeout);
      this.initialAutoplayTimeout = setTimeout(() => {
        this.initialAutoplayTimeout = null;
        this.play();
      }, 15000);
      return;
    }

    this.play();
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    clearTimeout(this.initialAutoplayTimeout);
    this.initialAutoplayTimeout = null;
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    clearTimeout(this.initialAutoplayTimeout);
    this.initialAutoplayTimeout = null;
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

function initOnelifeJudgeMeBridge() {
  if (!document.body.classList.contains('template-product')) return;

  const reviewBadge = document.querySelector('[id*="judge_me_badge"]');
  if (!reviewBadge || reviewBadge.dataset.olJudgemeBound === 'true') return;

  reviewBadge.dataset.olJudgemeBound = 'true';
  reviewBadge.setAttribute('role', 'button');
  reviewBadge.setAttribute('aria-label', 'Open customer reviews');
  reviewBadge.tabIndex = 0;

  const getReviewSection = () =>
    document.querySelector('.jdgm-rev-widg') ||
    document.querySelector('.jdgm-all-reviews-widget') ||
    document.querySelector('[id*="__judgeme"]');

  const getWriteReviewButton = () =>
    document.querySelector('.jdgm-write-rev-link') ||
    document.querySelector('[data-action="write-review"]');

  const getReviewCount = () => {
    const badge = reviewBadge.querySelector('.jdgm-prev-badge');
    const count = Number.parseInt(badge?.dataset.numberOfReviews || '0', 10);
    return Number.isNaN(count) ? 0 : count;
  };

  const scrollToReviews = () => {
    const target = getReviewSection();
    if (!target) return false;

    const scrollTarget = target.closest('.shopify-section') || target;
    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  };

  const triggerReviewFlow = (mode) => {
    const shouldOpenForm = mode === 'write' || getReviewCount() === 0;
    let attempts = 0;

    const run = () => {
      attempts += 1;
      scrollToReviews();

      if (!shouldOpenForm) {
        if (attempts > 1) window.clearInterval(interval);
        return;
      }

      const writeReviewButton = getWriteReviewButton();
      if (writeReviewButton && typeof writeReviewButton.click === 'function') {
        writeReviewButton.click();
        window.clearInterval(interval);
        return;
      }

      if (attempts >= 14) {
        window.clearInterval(interval);
      }
    };

    const interval = window.setInterval(run, 300);
    run();
  };

  const activateBadge = (event, mode) => {
    const clickableTarget =
      event.target.closest('.jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-star, .jdgm-prev-badge__text') ||
      event.target === reviewBadge;

    if (!clickableTarget) return;

    event.preventDefault();
    triggerReviewFlow(mode);
  };

  reviewBadge.addEventListener('click', (event) => activateBadge(event, 'open'));
  reviewBadge.addEventListener('keydown', (event) => {
    if (event.code !== 'Enter' && event.code !== 'Space') return;
    activateBadge(event, 'open');
  });

  const url = new URL(window.location.href);
  const requestedAction = url.searchParams.get('ol_reviews');
  const requestedMode = requestedAction === 'write' ? 'write' : requestedAction === 'open' ? 'open' : null;

  if (window.location.hash === '#judgeme_product_reviews' || requestedMode) {
    window.setTimeout(() => {
      triggerReviewFlow(requestedMode || 'open');
    }, 250);

    if (requestedMode) {
      url.searchParams.delete('ol_reviews');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }
  }
}

document.addEventListener('DOMContentLoaded', initOnelifeJudgeMeBridge);
window.addEventListener('load', initOnelifeJudgeMeBridge);

function initOnelifeProductTagGuideLinks() {
  const guidePath = '/pages/product-tag-guide?view=product-tag-guide-v7';
  const oldPaths = new Set([
    '/pages/faq',
    `${window.location.origin}/pages/faq`,
    'https://onelife.co.za/pages/faq',
  ]);

  const isTagGuideLink = (link) => {
    const href = link.getAttribute('href') || '';
    if (!oldPaths.has(href)) return false;

    const text = (link.textContent || '').toLowerCase();
    if (text.includes('tag guide') || text.includes('product tag') || text.includes('shopping guide')) return true;

    return !!link.closest('.ol-tag-disclaimer, .ol-cart-tag-disclaimer, .shop-tag-note, .vb-note, .ol-home-tabs__tag-note, .ol-footer-tag-guide, footer');
  };

  const normalize = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      if (isTagGuideLink(link)) {
        link.setAttribute('href', guidePath);
      }
    });
  };

  normalize();

  const observer = new MutationObserver(normalize);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);
}

document.addEventListener('DOMContentLoaded', initOnelifeProductTagGuideLinks);
window.addEventListener('load', initOnelifeProductTagGuideLinks);

function initOnelifeProductTagGuidePageRefresh() {
  if (window.location.pathname !== '/pages/product-tag-guide') return;
  if (document.querySelector('.ol-tag-hero')) return;

  const oldGuide = document.querySelector('.ol-tag-guide-page');
  if (!oldGuide) return;

  const globalScriptSrc = Array.from(document.scripts)
    .map((script) => script.src || '')
    .find((src) => src.includes('/assets/global.js'));
  const heroImage = globalScriptSrc
    ? globalScriptSrc.replace(/global\.js(?:\?.*)?$/, 'onelife-product-page-lifestyle-strip.jpg')
    : '/cdn/shop/t/40/assets/onelife-product-page-lifestyle-strip.jpg';
  const mount = oldGuide.closest('.shopify-section') || oldGuide.parentElement;
  if (!mount) return;

  mount.innerHTML = `
    <style id="ol-tag-guide-refresh-style">
      .ol-tag-guide{background:#f6f8f4;color:#17211b;overflow-x:hidden}.ol-tag-guide *{box-sizing:border-box}.ol-tag-hero{position:relative;min-height:430px;display:flex;align-items:center;background:linear-gradient(90deg,rgba(13,28,20,.78),rgba(13,28,20,.38) 48%,rgba(13,28,20,.06)),url("${heroImage}") center/cover no-repeat;color:#fff}.ol-tag-hero__inner{width:min(1180px,100vw);margin:0 auto;padding:58px 24px}.ol-tag-kicker{display:inline-flex;align-items:center;border:1px solid rgba(255,255,255,.36);border-radius:999px;background:rgba(255,255,255,.12);backdrop-filter:blur(8px);color:#eaf7ed;font-size:12px;font-weight:850;letter-spacing:.08em;text-transform:uppercase;padding:7px 12px;margin:0 0 18px}.ol-tag-hero h1,.ol-tag-hero .ol-tag-hero__inner h1{max-width:min(680px,calc(100vw - 32px));font-size:clamp(36px,5vw,64px);line-height:1.02;margin:0 0 16px;color:#fff!important;-webkit-text-fill-color:#fff!important;letter-spacing:0;text-wrap:balance}.ol-tag-hero__lead{max-width:min(650px,calc(100vw - 32px));font-size:18px;line-height:1.62;margin:0;color:rgba(255,255,255,.9);white-space:normal!important;overflow-wrap:break-word}.ol-tag-hero__actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:24px}.ol-tag-btn{display:inline-flex;align-items:center;justify-content:center;min-height:44px;border-radius:8px;padding:0 18px;font-size:14px;font-weight:850;text-decoration:none}.ol-tag-btn--light{background:#fff;color:#163625}.ol-tag-btn--ghost{border:1px solid rgba(255,255,255,.42);color:#fff;background:rgba(255,255,255,.1)}.ol-tag-shell{max-width:1180px;margin:0 auto;padding:34px 24px 58px}.ol-tag-trust{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-top:-58px;position:relative;z-index:2}.ol-tag-trust__item{background:#fff;border:1px solid #dde8dd;border-radius:8px;padding:18px;box-shadow:0 12px 34px rgba(26,39,31,.08)}.ol-tag-trust__item strong{display:block;color:#163625;font-size:14px;margin-bottom:5px}.ol-tag-trust__item span{display:block;color:#536157;font-size:13px;line-height:1.45}.ol-tag-note{border:1px solid #d1dfd1;border-radius:8px;background:#fff;color:#35443b;font-size:15px;line-height:1.62;margin:28px 0 0;padding:18px 20px}.ol-tag-note strong{color:#163625}.ol-tag-section{margin-top:34px}.ol-tag-section__head{display:flex;align-items:flex-end;justify-content:space-between;gap:18px;margin-bottom:16px}.ol-tag-section__head h2{font-size:clamp(25px,3vw,34px);line-height:1.15;margin:0;color:#111b15;letter-spacing:0}.ol-tag-section__head p{max-width:520px;margin:0;color:#5a665f;font-size:14px;line-height:1.55}.ol-tag-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px}.ol-tag-card{background:#fff;border:1px solid #e0e8df;border-radius:8px;padding:18px;min-height:158px;box-shadow:0 1px 2px rgba(18,28,22,.04)}.ol-tag-chip{display:inline-flex;align-items:center;border-radius:999px;background:#edf5ee;color:#1b4332;font-size:11px;font-weight:850;line-height:1;padding:7px 10px;margin-bottom:12px}.ol-tag-card h3{font-size:18px;line-height:1.22;margin:0 0 8px;color:#111b15;letter-spacing:0}.ol-tag-card p{font-size:13px;line-height:1.56;margin:0;color:#536157}.ol-tag-checks{display:grid;grid-template-columns:minmax(0,1.05fr) minmax(280px,.95fr);gap:18px;align-items:stretch}.ol-tag-panel{background:#fff;border:1px solid #dfe8df;border-radius:8px;padding:24px}.ol-tag-panel h2{font-size:24px;line-height:1.2;margin:0 0 14px;color:#111b15;letter-spacing:0}.ol-tag-list{display:grid;gap:11px;margin:0;padding:0;list-style:none}.ol-tag-list li{position:relative;padding-left:20px;color:#47564d;font-size:14px;line-height:1.55}.ol-tag-list li:before{content:"";position:absolute;left:0;top:.66em;width:7px;height:7px;border-radius:999px;background:#2d6a4f}.ol-tag-consult{background:#173c2a;color:#fff;border-radius:8px;padding:24px;display:flex;flex-direction:column;justify-content:space-between;min-height:100%}.ol-tag-consult h2{font-size:24px;line-height:1.2;margin:0 0 10px;color:#fff;letter-spacing:0}.ol-tag-consult p{color:rgba(255,255,255,.82);font-size:14px;line-height:1.58;margin:0 0 18px}.ol-tag-consult .ol-tag-btn{width:max-content}@media(max-width:899px){.ol-tag-hero{min-height:460px;background-position:center}.ol-tag-trust,.ol-tag-grid,.ol-tag-checks{grid-template-columns:1fr 1fr}.ol-tag-checks{align-items:start}.ol-tag-consult{grid-column:1/-1}.ol-tag-section__head{display:block}.ol-tag-section__head p{margin-top:8px}}@media(max-width:599px){.ol-tag-hero{min-height:520px;background:linear-gradient(180deg,rgba(13,28,20,.78),rgba(13,28,20,.42)),url("${heroImage}") center/cover no-repeat}.ol-tag-hero__inner{padding:42px 16px;max-width:100%}.ol-tag-hero__lead{font-size:16px;line-height:1.55;max-width:100%}.ol-tag-hero__actions{display:grid}.ol-tag-btn{width:100%}.ol-tag-shell{padding:24px 16px 42px}.ol-tag-trust{grid-template-columns:1fr;margin-top:-38px}.ol-tag-grid{grid-template-columns:1fr}.ol-tag-card{min-height:0}.ol-tag-checks{grid-template-columns:1fr}.ol-tag-panel,.ol-tag-consult{padding:18px}.ol-tag-consult .ol-tag-btn{width:100%}}
    </style>
    <main class="ol-tag-guide">
      <section class="ol-tag-hero">
        <div class="ol-tag-hero__inner">
          <p class="ol-tag-kicker">Product Tags</p>
          <h1>Shop tags help you shortlist faster.</h1>
          <p class="ol-tag-hero__lead">Use tags to shortlist faster.<br>Check the product label before purchase.</p>
          <div class="ol-tag-hero__actions">
            <a class="ol-tag-btn ol-tag-btn--light" href="/pages/shop">Shop Products</a>
            <a class="ol-tag-btn ol-tag-btn--ghost" href="https://wa.me/27769135059?text=Hi%2C%20I%20need%20help%20checking%20a%20product%20tag%20or%20ingredient" target="_blank" rel="noopener">Ask a Consultant</a>
          </div>
        </div>
      </section>
      <div class="ol-tag-shell">
        <div class="ol-tag-trust" aria-label="How product tags should be used">
          <div class="ol-tag-trust__item"><strong>Supplier-based guidance</strong><span>Tags are based on supplier, manufacturer and product information available to One Life Health.</span></div>
          <div class="ol-tag-trust__item"><strong>Label first</strong><span>Ingredients, allergen warnings and directions on the product pack remain the final reference.</span></div>
          <div class="ol-tag-trust__item"><strong>Expert help available</strong><span>Our consultants can help you check a product if you are unsure about suitability.</span></div>
        </div>
        <div class="ol-tag-note"><strong>Important:</strong> product tags are a shopping guide only. Always check the product label, ingredients list and allergen information before purchase or use. If you have allergies, are pregnant or breastfeeding, take medication, have a medical condition, or are unsure whether a product is suitable, ask a One Life Health consultant or a qualified healthcare professional first.</div>
        <section class="ol-tag-section">
          <div class="ol-tag-section__head"><h2>What each tag means</h2><p>These definitions explain how to read the tags on One Life product cards. They are not medical, allergen or formulation guarantees.</p></div>
          <div class="ol-tag-grid" aria-label="Product tag meanings">
            <article class="ol-tag-card"><span class="ol-tag-chip">Dietary</span><h3>Gluten Free</h3><p>Used where supplier or product information indicates a gluten-free claim or no gluten-containing ingredients. Always check the allergen statement.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Dietary</span><h3>Sugar Free</h3><p>Used where supplier or product information indicates no added sugar or a sugar-free claim. Check the nutrition panel for sweeteners and total carbohydrates.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Allergen</span><h3>Dairy Free</h3><p>Used where product information indicates no dairy ingredients. If you have a dairy allergy, check the label for allergen and cross-contact warnings.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Lifestyle</span><h3>Vegan</h3><p>Used where supplier or product information indicates a vegan formulation. Check capsules, flavourings and additives if strict vegan suitability matters.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Lifestyle</span><h3>Vegetarian</h3><p>Used where supplier or product information indicates vegetarian suitability. Check capsule type and any animal-derived ingredients on the label.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Origin</span><h3>SA Made</h3><p>Used where product or supplier information indicates South African manufacturing, production or packing. It does not automatically mean every ingredient is locally sourced.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Ingredient claim</span><h3>Organic</h3><p>Used where product information includes an organic claim. Check the product label for the exact organic certification or ingredient-level claim.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Ingredient claim</span><h3>Non-GMO</h3><p>Used where supplier or product information indicates a non-GMO claim. Check the packaging for the exact scope of the claim.</p></article>
            <article class="ol-tag-card"><span class="ol-tag-chip">Dietary</span><h3>Keto</h3><p>Used as a low-carb shopping aid where available product information supports keto-friendly use. Check macros and serving size against your own plan.</p></article>
          </div>
        </section>
        <section class="ol-tag-section ol-tag-checks">
          <div class="ol-tag-panel"><h2>How to use tags safely</h2><ul class="ol-tag-list"><li>Use tags to narrow your search, not as the only basis for purchase.</li><li>Read the actual product label and ingredients before checkout and before use.</li><li>Check allergen warnings, cross-contact warnings and serving directions.</li><li>Confirm suitability with a consultant or healthcare professional if you are unsure.</li></ul></div>
          <div class="ol-tag-consult"><div><h2>Need help checking a product?</h2><p>Send us the product name or a label photo and we will help you confirm the ingredient and tag details before you buy.</p></div><a class="ol-tag-btn ol-tag-btn--light" href="https://wa.me/27769135059?text=Hi%2C%20I%20need%20help%20checking%20a%20product%20tag%20or%20ingredient" target="_blank" rel="noopener">Chat on WhatsApp</a></div>
        </section>
      </div>
    </main>`;
}

document.addEventListener('DOMContentLoaded', initOnelifeProductTagGuidePageRefresh);
window.addEventListener('load', initOnelifeProductTagGuidePageRefresh);

function initOnelifeKlaviyoCommunityFallback() {
  if (window.__olKlaviyoCommunityFallbackStarted) return;
  window.__olKlaviyoCommunityFallbackStarted = true;

  const publicKey = 'S86r7e';
  const listId = 'Xrk5jD';
  const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`;

  const statusNode = (form) => {
    let node = form.querySelector('[data-ol-klaviyo-status]');
    if (node) return node;
    node = document.createElement('p');
    node.setAttribute('data-ol-klaviyo-status', '');
    node.setAttribute('role', 'status');
    node.style.margin = '10px 0 0';
    node.style.fontSize = '12px';
    form.appendChild(node);
    return node;
  };

  const setStatus = (form, message, ok) => {
    const node = statusNode(form);
    const darkSurface = form.getAttribute('data-ol-klaviyo-status-tone') === 'dark';
    node.textContent = message;
    node.style.color = ok ? (darkSurface ? '#d4f5ef' : '#1b4332') : (darkSurface ? '#ffe4e6' : '#9f1239');
  };

  const formSource = (form) => {
    const source = form.querySelector('[name="ol_klaviyo_source"]');
    return source && source.value ? source.value : form.id || 'site_signup';
  };

  const formProperties = (form) => {
    const properties = {
      source: formSource(form),
      signup_path: window.location.pathname,
      signup_url: window.location.href,
    };
    const offer = form.querySelector('[name="ol_klaviyo_offer"]');
    if (offer && offer.value) properties.offer = offer.value;
    form.querySelectorAll('[data-ol-klaviyo-property]').forEach((input) => {
      const match = String(input.name || input.getAttribute('data-ol-klaviyo-property') || '').match(/^properties\[(.+)\]$/);
      const name = match ? match[1] : input.name || input.getAttribute('data-ol-klaviyo-property');
      if (name && input.value !== '') properties[name] = input.value;
    });
    return properties;
  };

  const subscriptionPayload = (email, form) => ({
    data: {
      type: 'subscription',
      attributes: {
        custom_source: formSource(form),
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email,
              properties: formProperties(form),
            },
          },
        },
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: listId,
          },
        },
      },
    },
  });

  const pushKlaviyoBrowserEvents = (email, form) => {
    if (!window._learnq || typeof window._learnq.push !== 'function') return;
    const properties = formProperties(form);
    window._learnq.push(['identify', Object.assign({ '$email': email }, properties)]);
    window._learnq.push(['track', 'One Life Signup Submitted', properties]);
  };

  const bindForm = (form) => {
    if (!form || form.getAttribute('data-ol-klaviyo-bound') === 'true') return;
    form.setAttribute('data-ol-klaviyo-bound', 'true');
    form.addEventListener('submit', (event) => {
      const emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
      if (!emailInput || !emailInput.value) return;
      const consent = form.querySelector('[name="ol_marketing_consent"]');
      if (consent && !consent.checked) return;

      event.preventDefault();
      const button = form.querySelector('button[type="submit"], input[type="submit"]');
      const previousLabel = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        if (button.textContent) button.textContent = 'Joining...';
      }
      setStatus(form, 'Adding you to the apothecary list...', true);

      fetch(endpoint, {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-04-15',
        },
        body: JSON.stringify(subscriptionPayload(emailInput.value.trim(), form)),
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Klaviyo subscription failed: ${response.status}`);
          pushKlaviyoBrowserEvents(emailInput.value.trim(), form);
          form.reset();
          setStatus(form, 'You are on the list. Check your inbox for your offer.', true);
        })
        .catch(() => {
          setStatus(form, 'Something went wrong. Please try again.', false);
        })
        .finally(() => {
          if (button) {
            button.disabled = false;
            if (previousLabel) button.textContent = previousLabel;
          }
        });
    });
  };

  const bindAll = () => {
    document
      .querySelectorAll('#ContactFooter, #ol-blog-popup-form, #ol-community-klaviyo-form, [data-ol-klaviyo-signup]')
      .forEach(bindForm);
  };

  const refreshCommunityBlock = () => {
    bindAll();
    if (document.querySelector('#ol-community-klaviyo-form')) return;
    const community = document.querySelector('#ol-community');
    if (!community || !/VIEW REWARDS\s*&\s*BENEFITS/i.test(community.textContent || '')) return;

    fetch(`/?section_id=onelife-community-signup&ol_klaviyo_refresh=${Date.now()}`, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        if (!html) return;
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        const freshCommunity = template.content.querySelector('#ol-community');
        if (!freshCommunity || !freshCommunity.querySelector('#ol-community-klaviyo-form')) return;
        community.replaceWith(freshCommunity);
        bindAll();
      })
      .catch(() => {});
  };

  refreshCommunityBlock();
  window.setTimeout(refreshCommunityBlock, 1200);
  window.setTimeout(refreshCommunityBlock, 3200);
}

document.addEventListener('DOMContentLoaded', initOnelifeKlaviyoCommunityFallback);
window.addEventListener('load', initOnelifeKlaviyoCommunityFallback);
